import { Theme } from '@mui/material';

export const PerformanceStylesCSS = (theme: Theme) => ({
  dashBoardContainer: {
    padding: theme.spacing(2, 2, 2, 1),
    position: 'relative',
  },
  width5: {
    width: '5%',
  },
  width10: {
    width: '10%',
  },
  width15: {
    width: '15%',
  },
  width20: {
    width: '20%',
  },
  width25: {
    width: '25%',
  },
  width30: {
    width: '30%',
  },
  width35: {
    width: '35%',
  },
  tableContainer: {
    border: `1px solid ${theme.palette.customGrey.adminButtonBorder}`,
    borderTop: 'none',
    borderRadius: theme.spacing(0, 1.5, 1.5, 1.5),
    backgroundColor: theme.palette.customWhite.main,
  },
  tableRowBorder: {
    borderBottom: `1px solid ${theme.palette.customGrey.adminButtonBorder}`,
  },
  tableRowHover: {
    '&:focus, &:hover': {
      backgroundColor: theme.palette.customGrey.adminButtonBorder,
    },
  },
  tableRowEven: {
    backgroundColor: theme.palette.customBackground.dragBackground,
  },
  tableCellTextAlignLeft: {
    '&.MuiTableCell-root': {
      textAlign: 'left',
    },
  },
  sliderTableContainer: {
    borderRadius: 0,
    border: 'none',
    height: '82vh',
    '&::-webkit-scrollbar': {
      width: 10,
    },
    '&::-webkit-scrollbar-track': {
      backgroundColor: theme.palette.customGrey.adminButtonBorder,
    },
    '&::-webkit-scrollbar-thumb': {
      backgroundColor: theme.palette.customBlue.primaryBlue,
      borderRadius: 2,
    },
    overflowX: 'hidden',
  },
  drawerHeader: {
    width: '100%',
    height: theme.spacing(10),
    backgroundColor: theme.palette.customBlue.primaryBlue,
    color: theme.palette.customWhite.main,
    padding: theme.spacing(2),
  },
  drawerHeaderIcon: {
    color: theme.palette.customWhite.main,
    fontWeight: 'bold',
  },
  drawerTableColumn1: {
    '&.MuiTableCell-root': {
      backgroundColor: theme.palette.customWhite.main,
      color: theme.palette.customBlack.dimmedBlack,
      textAlign: 'left',
    },
  },
  drawerTableColumn: {
    '&.MuiTableCell-root': {
      backgroundColor: theme.palette.customWhite.main,
      color: theme.palette.customBlack.dimmedBlack,
    },
  },
  tag: {
    display: 'inline-block',
    width: theme.spacing(5),
    marginRight: theme.spacing(1),
    borderRadius: theme.spacing(1.35),
    fontWeight: 'bold',
  },
  tagDisabled: {
    backgroundColor: theme.palette.customGrey.adminButtonBorder,
    color: theme.palette.fontColors.fontBlack,
  },
  tagRed: {
    background: theme.palette.customRed.buttonFontRed,
    color: theme.palette.customWhite.main,
  },
  tagYellow: {
    background: theme.palette.customYellow.main,
    color: theme.palette.customWhite.main,
  },
  tagBlue: {
    background: theme.palette.customBlue.waterBlue,
    color: theme.palette.customWhite.main,
  },
  tagGreen: {
    background: theme.palette.customGreen.fontGreen,
    color: theme.palette.customWhite.main,
  },
  tagPurple: {
    background: theme.palette.customBlue.purpleBright,
    color: theme.palette.customWhite.main,
  },
});
